import { getAllUrlParams } from '@atlassian/jira-issue-fetch-services-common/src/common/utils/permalinks.tsx';

export const ONBOARDING_PARAM_KEY = 'onboardingIdeaKey';

export const useSelectedIdeaKey = () => {
	const params = getAllUrlParams();
	return params[ONBOARDING_PARAM_KEY];
};
